import { useEffect } from "react";

/* load fontawesome script after client render, prevents hydration error */
const FontAwesome = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://kit.fontawesome.com/f1ab532a0e.js";
    script.crossOrigin = "anonymous";
    document.head.appendChild(script);
  }, []);

  return null;
};

export default FontAwesome;
